import React from 'react';
import Icon from '@/components/ui/AppIcon';

interface HeroSectionProps {
  onApplyClick: () => void;
}

const HeroSection = ({ onApplyClick }: HeroSectionProps) => {
  return (
    <section className="relative bg-gradient-to-br from-primary via-primary to-secondary text-primary-foreground py-20 lg:py-32 overflow-hidden">
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-20 left-10 w-64 h-64 bg-accent rounded-full blur-3xl"></div>
        <div className="absolute bottom-20 right-10 w-96 h-96 bg-secondary rounded-full blur-3xl"></div>
      </div>
      
      <div className="container mx-auto px-4 relative z-10">
        <div className="max-w-4xl mx-auto text-center">
          <div className="inline-flex items-center gap-2 bg-accent/20 backdrop-blur-sm px-4 py-2 rounded-full mb-6">
            <Icon name="SparklesIcon" size={20} variant="solid" className="text-accent" />
            <span className="text-sm font-semibold font-cta">Join Our Curated Network</span>
          </div>
          
          <h1 className="text-4xl lg:text-6xl font-bold font-headline mb-6 leading-tight">
            Transform Your Consulting Practice with AI Change Leadership
          </h1>
          
          <p className="text-xl lg:text-2xl text-primary-foreground/90 mb-8 leading-relaxed font-body">
            Join an exclusive alliance of senior consultants and boutique firms delivering human-centered AI transformations to enterprise clients.
          </p>
          
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
            <button
              onClick={onApplyClick}
              className="px-8 py-4 bg-accent text-accent-foreground rounded-lg font-semibold font-cta text-lg hover:bg-accent/90 transition-all duration-300 shadow-strong hover:shadow-xl hover:-translate-y-1 flex items-center gap-2"
            >
              Apply to Join Network
              <Icon name="ArrowRightIcon" size={20} variant="solid" />
            </button>
            
            <a
              href="#benefits"
              className="px-8 py-4 bg-primary-foreground/10 backdrop-blur-sm text-primary-foreground rounded-lg font-semibold font-cta text-lg hover:bg-primary-foreground/20 transition-all duration-300 flex items-center gap-2"
            >
              Explore Benefits
              <Icon name="ChevronDownIcon" size={20} variant="outline" />
            </a>
          </div>
          
          <div className="mt-12 grid grid-cols-1 sm:grid-cols-3 gap-6 max-w-3xl mx-auto">
            <div className="bg-primary-foreground/10 backdrop-blur-sm rounded-lg p-6">
              <div className="text-3xl font-bold font-headline mb-2">150+</div>
              <div className="text-sm text-primary-foreground/80 font-body">Active Partners</div>
            </div>
            <div className="bg-primary-foreground/10 backdrop-blur-sm rounded-lg p-6">
              <div className="text-3xl font-bold font-headline mb-2">£2.5M+</div>
              <div className="text-sm text-primary-foreground/80 font-body">Partner Revenue 2025</div>
            </div>
            <div className="bg-primary-foreground/10 backdrop-blur-sm rounded-lg p-6">
              <div className="text-3xl font-bold font-headline mb-2">94%</div>
              <div className="text-sm text-primary-foreground/80 font-body">Partner Satisfaction</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;